import { connect } from 'react-redux'
import { Filter } from './Filter.jsx'

const mapDispatchToProps = (dispatch, ownProps) => ({
    onChange: (event, value) => {
        if(typeof ownProps.changeAction === "function") dispatch(ownProps.changeAction(value))
    },
})

export const FilterContainer = connect(
    undefined,
    mapDispatchToProps
)(Filter)
